let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2b5QF")).then(() => parcelRequire('1FDBc'));